import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import $axios from './index';

export const fetchBannersByType = createAsyncThunk('banner/fetchBannersByType', async (type) => {
  let response = [null, null];
  try {
    const res = await $axios.get(`/banners?type=${type}`);
    response = [res.data.data, null];
  } catch (err) {
    response = [null, err?.response?.data?.message || err?.response || 'Something went wrong'];
  }
  return response;
});

export const fetchBannerById = createAsyncThunk('banner/fetchBannerById', async (id) => {
  let response = [null, null];
  try {
    const res = await $axios.get(`/banners/${id}`);
    response = [res.data.data, null];
  } catch (err) {
    response = [null, err?.response?.data?.message || err?.response || 'Something went wrong'];
  }
  return response;
});

export const createBanner = createAsyncThunk('banner/createBanner', async (payload) => {
  let response = [null, null];
  try {
    const res = await $axios.post('/banners', payload);
    response = [res.data.data, null];
  } catch (err) {
    response = [null, err?.response?.data?.message || err?.response || 'Something went wrong'];
  }
  return response;
});

export const updateBanner = createAsyncThunk('banner/updateBanner', async ({ id, data }) => {
  let response = [null, null];
  try {
    const res = await $axios.put(`/banners/${id}`, data);
    response = [res.data.data, null];
  } catch (err) {
    response = [null, err?.response?.data?.message || err?.response || 'Something went wrong'];
  }
  return response;
});

export const deleteBanner = createAsyncThunk('banner/deleteBanner', async (id) => {
  let response = [null, null];
  try {
    await $axios.delete(`/banners/${id}`);
    response = [id, null];
  } catch (err) {
    response = [null, err?.response?.data?.message || err?.response || 'Something went wrong'];
  }
  return response;
});

const bannerSlice = createSlice({
  name: 'banner',
  initialState: {
    bannersByType: {},
    singleBanner: null,
    bannerCreated: null,
    bannerUpdated: null,
    bannerDeleted: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearSingleBanner: (state) => {
      state.singleBanner = null;
    },
    clearBannerFlags: (state) => {
      state.bannerCreated = null;
      state.bannerUpdated = null;
      state.bannerDeleted = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    // Fetch by type
    builder
      .addCase(fetchBannersByType.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBannersByType.fulfilled, (state, action) => {
        state.loading = false;
        const [data, err] = action.payload;
        if (err) {
          state.error = err;
          return;
        }
        state.error = null;
        const type = action.meta.arg;
        state.bannersByType = { ...state.bannersByType, [type]: data };
      });

    // Fetch by id
    builder
      .addCase(fetchBannerById.pending, (state) => {
        state.singleBanner = null;
      })
      .addCase(fetchBannerById.fulfilled, (state, action) => {
        state.singleBanner = action.payload;
      });

    // Create
    builder.addCase(createBanner.fulfilled, (state, action) => {
      const [data, err] = action.payload;
      if (err) {
        state.error = err;
        state.bannerCreated = null;
        return;
      }
      state.bannerCreated = data;
      state.error = null;
    });

    // Update
    builder.addCase(updateBanner.fulfilled, (state, action) => {
      const [data, err] = action.payload;
      if (err) {
        state.error = err;
        state.bannerUpdated = null;
        return;
      }
      state.bannerUpdated = data;
      state.error = null;
      if (data && data.type && state.bannersByType[data.type]) {
        state.bannersByType[data.type] = state.bannersByType[data.type].map((b) => (String(b._id) === String(data._id) ? data : b));
      }
    });

    // Delete
    builder.addCase(deleteBanner.fulfilled, (state, action) => {
      const [deletedId, err] = action.payload;
      if (err) {
        state.error = err;
        state.bannerDeleted = null;
        return;
      }
      state.bannerDeleted = deletedId;
      state.error = null;
      Object.keys(state.bannersByType).forEach((type) => {
        state.bannersByType[type] = (state.bannersByType[type] || []).filter((b) => String(b._id) !== String(deletedId));
      });
    });
  },
});

export const { clearSingleBanner, clearBannerFlags } = bannerSlice.actions;
export default bannerSlice.reducer;
